<template>
  <div class="list-group-container">
    <div>
      <div class="company-info-section">
        <p>Company Information</p>
      </div>
      <div class="row">
        <div class="form-group profile-pic text-center col-md-4 col-sm-12">
          <section id="section-type">
            <div class="text-center">
              <img :src="profilePicture" class="mx-auto" width="160px" height="auto" />
              <br />

              <div>
                <input
                  type="file"
                  name="company-logo-file"
                  id="company-logo-file"
                  class="input-file"
                  accept="image/jpeg, image/png"
                  @change="previewImage"
                />
                <i class="fas fa-camera"></i>
                <label for="company-logo-file" id="upload-label-link">Change logo</label>
              </div>
            </div>
          </section>
        </div>

        <div class="col-md-8 col-sm-12 px-5">
          <section id="section-type">
            <div class="form-group">
              <label>Name</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-name"
                >{{ companyDetails.company_name }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Contact Number</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-phone"
                >{{ companyDetails.company_phone }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>How do you identify your company or organization?</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-info"
                >{{ companyDetails.building_type }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Company Background</label>
              <div class="type-pass-content">
                <label class="form-check-label" for="company-info">{{ companyDetails.company_info }}</label>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <br />
    <br />

    <div>
      <div class="company-info-section">
        <p>Address Information</p>
      </div>
      <div class="row">
        <div class="col-sm-12 px-5">
          <section id="section-type">
            <div class="form-group">
              <label>Country</label>
              <div class="type-pass-content">
                <label class="form-check-label" for="company-info">{{ companyDetails.country }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Province</label>
              <div class="type-pass-content">
                <label class="form-check-label" for="company-info">{{ companyDetails.province }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>City</label>
              <div class="type-pass-content">
                <label class="form-check-label" for="company-info">{{ companyDetails.city }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Building Name</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-info"
                >{{ companyDetails.building_name }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Floor and unit number</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-info"
                >{{ companyDetails.company_floor }}</label>
              </div>
            </div>
          </section>

          <section id="section-type">
            <div class="form-group">
              <label>Address</label>
              <div class="type-pass-content">
                <label
                  class="form-check-label"
                  for="company-info"
                >{{ companyDetails.building_address }}</label>
              </div>
            </div>
          </section>
        </div>
      </div>
    </div>

    <section>
      <div class="company-info-section">
        <p>Other Details</p>
      </div>
      <div class="row">
        <div class="col-sm-12 px-5">
          <div class="form-group">
            <label>
              Are you responsible on managing the building premises?
              <br />Eg. Handles concierge and receptions.
            </label>
            <div class="type-pass-content">
              <label
                class="form-check-label"
                for="company-info"
              >{{ companyDetails.is_building_owner == 'true' ? 'Yes' : 'No' }}</label>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section class="d-flex justify-content-center mb-4">
      <button @click="changeToEditForm()" type="submit" class="btn btn-primary">Update Details</button>
    </section>
  </div>
</template>

<script>
const placeholderImage = 'http://placehold.jp/ebf0f5/9db4cc/150x150.png?text=YP'

export default {
  data() {
    return {
      profilePicture: this.companyDetails.company_logo_url || placeholderImage
    }
  },
  props: {
    companyDetails: Object,
    changeToEditForm: Function,
    previewImage: Function
  }
}
</script>

<style scoped>
.company-info-section {
  background-color: #fafafa;
}

.company-info-section p {
  padding-top: 30px;
  padding-left: 25px;
  padding-bottom: 30px;
  font-weight: bold;
  color: #6c757d;
}
</style>



// WEBPACK FOOTER //
// src/containers/business_profile/ProfileViewDetail.vue